module.exports = __webpack_public_path__ + "images/icons_v2/juul-pod-pack-triple-green-7cab4296.svg";